import {
  Fixture,
  ICCReview,
  Org,
  Player,
  Team,
  Tournament,
  User,
  Venue,
} from 'src/api';
import { MainMenuOption } from 'src/service/MainMenu';
import { AbstractUserRole } from 'src/service/UserPermission/AbstractUserRole';

export class UnionAdminRole extends AbstractUserRole {
  canView(option: MainMenuOption): boolean {
    const allowed = [
      MainMenuOption.union,
      MainMenuOption.team,
      MainMenuOption.player,
      MainMenuOption.event,
      MainMenuOption.assessment,
      MainMenuOption.user,
      MainMenuOption.home,
      MainMenuOption.tournament,
      MainMenuOption.venue,
      MainMenuOption.iccreview,
    ];
    return allowed.includes(option);
  }
  canSeeCompletedTournaments(): boolean {
    return true;
  }

  canEditUnion(union: Org): boolean {
    const unionId = union?.id;
    if (unionId === 0) return true; // adding
    if (unionId === undefined) return false; // must know the union
    return this.list.has(unionId);
  }

  canEditTeam(team: Team): boolean {
    return this.list.has(team?.orgId ?? 0);
  }

  canEditPlayer(player: Player): boolean {
    // player is part of a union i admin
    return (
      player.playerTeams?.some((playerTeams) =>
        this.list.has(playerTeams.team?.orgId ?? 0),
      ) ?? false
    );
  }

  canEditUser(user: User): boolean {
    // if the user has a role in my union
    return (
      (user.roles?.some((role) => this.list.has(role.org?.id ?? 0)) ?? false) ||
      (user.roles?.some((role) => this.list.has(role.team?.orgId ?? 0)) ??
        false)
    );
  }

  canEditTournament(tournament: Tournament): boolean {
    return (
      tournament.teams?.some((team) => this.list.has(team.orgId ?? 0)) ?? false
    );
  }

   
  canEditVenue(venue: Venue): boolean {
    return true;
  }

  canViewFixture(fixture: Fixture): boolean {
    return (
      this.list.has(fixture.homeTeam?.orgId ?? 0) ||
      this.list.has(fixture.oppositionTeam?.orgId ?? 0)
    );
  }

  canAddMDDToFixture(fixture: Fixture): boolean {
    return this.canViewFixture(fixture);
  }

  canViewICCReview(review: ICCReview): boolean {
    return (
      review.event?.player?.playerTeams?.some((playerTeams) =>
        this.list.has(playerTeams.team?.orgId ?? 0),
      ) ?? false
    );
  }

  canToggleICCCompliance(): boolean {
    return true;
  }
}
